module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-home ui-styles",
    class: _vm.theme,
    attrs: {
      "id": "projects-index"
    }
  }, [
    [(_vm.master_loading) ? _c('div', {
      staticClass: "loading_view"
    }, [_c('div', {
      staticClass: "view_spinner_container"
    }, [_c('span', {
      staticStyle: {
        "color": "rgb(0, 79, 146)",
        "margin": "0 auto"
      }
    }, [_c('icon', {
      attrs: {
        "name": "spinner",
        "scale": "4",
        "color": "rgb(0, 79, 146)",
        "spin": ""
      }
    })], 1), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Loading')) + "...")])])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "master_view"
    }, [_c('side-nav-bar', {
      attrs: {
        "filesOpen": _vm.filesOpen,
        "fileOpen": _vm.fileOpen,
        "realEstateId": _vm.realestate.id
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "app-container"
    }, [_c('bar'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('Project')) + " " + _vm._s(_vm.$t('with')) + " " + _vm._s(_vm.$t('date')) + " " + _vm._s(_vm.project.projectdate) + " " + _vm._s(_vm.$t('at')) + " "), (_vm.realestate.street_name) ? _c('span', [_vm._v(_vm._s(_vm.realestate.street_name))]) : _vm._e(), (_vm.realestate.street_number) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.street_number))]) : _vm._e(), (_vm.realestate.floor) ? _c('span', [_vm._v(", " + _vm._s(_vm.realestate.floor))]) : _vm._e(), (_vm.realestate.door) ? _c('span', [_vm._v(" " + _vm._s(_vm.realestate.door))]) : _vm._e(), _vm._v(" "), (_vm.project.dirty) ? _c('span', [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (_vm.project.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datedata"
    }, [_c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Created')) + ": " + _vm._s(_vm.millis_to_time(_vm.project.date_created)))]), _vm._v(" "), _c('p', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.$t('Last_modified')) + ": " + _vm._s(_vm.millis_to_time(_vm.project.date_modified)))])]), _vm._v(" "), _c('vue-tabs', {
      model: {
        value: (_vm.tabName),
        callback: function($$v) {
          _vm.tabName = $$v
        },
        expression: "tabName"
      }
    }, [_c('v-tab', {
      attrs: {
        "title": _vm.General_data_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Dades generals')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('General data')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Datos generales')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.General_data_text))]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Project_type')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })])])])])]), _vm._v(" "), _c('v-tab', {
      attrs: {
        "title": _vm.metadata_text
      }
    }, [(_vm.currentLocale === 'ca') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadades')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : (_vm.currentLocale === 'en') ? _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadatos')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]) : _c('div', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setCurrentTabTitle('Metadata')
        }
      },
      slot: "title"
    }, [_vm._v(_vm._s(_vm.metadata_text) + "\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "tab_content"
    }, [_c('div', [_c('form', {
      staticClass: "bt-form"
    }, [_c('div', {
      staticClass: "section-container"
    }, [_c('h3', [_vm._v(_vm._s(_vm.$t('Description')))]), _vm._v(" "), _c('div', {
      staticClass: "field-container"
    })])])])])])], 1), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onGoUp($event)
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "level-up",
        "text": _vm.goup_button_text,
        "icon_color": "black",
        "text_color": "black",
        "border_color": "lightgray"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentProject({
            go_up: false
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), _c('div', [_c('div', {
      staticStyle: {
        "width": "fit-content",
        "margin-left": "auto"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onSaveCurrentProject({
            go_up: true
          })
        }
      }
    }, [_c('icon-button', {
      attrs: {
        "icon": "floppy-o",
        "text": _vm.save_and_go_up_button_text,
        "icon_color": "white",
        "text_color": "white",
        "border_color": "#006bc5",
        "background_color": "#0087F8"
      }
    })], 1)]), _vm._v(" "), (_vm.project.dirty) ? _c('message', {
      attrs: {
        "text": _vm.page_dirty_text,
        "icon_name": "info",
        "icon_color": "rgb(0, 135, 248)",
        "border_color": "rgb(0, 135, 248)",
        "text_color": "rgb(0, 135, 248)"
      }
    }) : _vm._e()], 1)], 1)]
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-42c85e8c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/projects/ProjectEditor.vue
// module id = 2137
// module chunks = 0